import type { DateTime } from 'luxon'

export function compareStrings(a: string, b: string) {
	return a.localeCompare(b)
}

export function compareNumber(a: number, b: number) {
	return a - b
}

export function compareDates(a: DateTime, b: DateTime) {
	return a.toMillis() - b.toMillis()
}
